import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  amazonRedactedInfoBanner: {
    defaultMessage:
      "Information associated with this Amazon order was redacted 30 days after delivery. This is in compliance with Amazon's Data Retention and Recovery Policy. <a>Learn more</a>",
    description: 'Message indicating why certain information is redacted from an Amazon order',
    id: '7XeTjl',
  },
});
